import { create, all } from "mathjs";

const config = {
  number: "BigNumber",
};
const math = create(all, config);

/**
 * 加法
 * @param {*} val1
 * @param {*} val2
 */
export function add(val1, val2) {
  return math.number(math.add(math.bignumber(val1), math.bignumber(val2)));
}
/**
 * 减法
 * @param {*} val1
 * @param {*} val2
 */
export function subtract(val1, val2) {
  return math.number(math.subtract(math.bignumber(val1), math.bignumber(val2)));
}
/**
 * 乘法
 * @param {*} val1
 * @param {*} val2
 */
export function multiply(val1, val2) {
  return math.number(math.multiply(math.bignumber(val1), math.bignumber(val2)));
}
/**
 * 除法
 * @param {*} val1
 * @param {*} val2
 */
export function divide(val1, val2) {
  return math.number(math.divide(math.bignumber(val1), math.bignumber(val2)));
}
